import { ErrorBoundary } from 'react-error-boundary';
import { ErrorInfo, useEffect, useState } from 'react';
import { ErrorPage } from 'modules/app/components/pages/error-page/ErrorPage';
import { Outlet, useLocation } from 'react-router-dom';
import { logger } from '@sanlam-glacier/app-common/modules/logger';
import { TopAppBar } from '../../organisms/top-app-bar/TopAppBar';
import styles from './holders.module.scss';
import { useAuth } from 'auth';
import { Paper } from '@sanlam-glacier/app-common/components';
import { SideNavMenu } from 'components/organisms/side-nav-bar/SideNavMenu';
import { BannerHolder } from '@sanlam-glacier/app-common/modules/banners';
import { isOnHomePage } from 'routes/route-paths';
import { BannerStaySafe } from '../../molecules/banner-staysafe/BannerStaySafe';
import './app-layout.scss';
import { PageBreadcrumbs } from '../../molecules/page-breadcrumbs/PageBreadcrumbs';

export const AppLayout = () => {
  const authContext = useAuth();
  const authenticated = authContext.identificationState === 'authenticated';
  const showSideNav = authenticated;
  const [isNavMounted, setIsNavMounted] = useState(false);
  useEffect(() => {
    if (!isNavMounted) return;
    // display banner here
  }, [isNavMounted]);
  const currentLocation = useLocation();
  const pathname = currentLocation.pathname;
  const isCurrentlyOnHomePage = isOnHomePage(pathname);

  const sideNavInnerClass = `default-base-layout-side-nav-inner${showSideNav ? '' : ' side-nav-hidden'}`;
  return (
    <div className='base-layout '>
      <div className='default-base-layout-container '>
        <ErrorBoundary
          FallbackComponent={ErrorPage}
          onError={(error: Error, info: ErrorInfo) => {
            logger.error({
              message: 'Page Crash',
              object: {
                error,
                info
              },
              includeTrace: true
            });
          }}
        >
          {' '}
          <div className='default-base-layout-top-bar-container'>
            <TopAppBar />
          </div>
          {showSideNav && (
            <div className='default-base-layout-side-nav-container'>
              <Paper
                shadow={Paper.SHADOW.MEDIUM}
                elevation={true}
                className='default-base-layout-side-nav'
              >
                <SideNavMenu mountSideNav={() => setIsNavMounted(true)} />
              </Paper>
            </div>
          )}
          <div className={sideNavInnerClass} id={'main-app-content-window'}>
            <BannerHolder
              customBanner={isCurrentlyOnHomePage ? <BannerStaySafe /> : null}
              innerClassName={styles.customBannerHolderInner}
              outerClassName={styles.customBannerHolderOuter}
            />
            <div
              className={`default-base-layout-breadcrumb-container ${isCurrentlyOnHomePage ? 'stay-safe-online-placeholder' : ''}`}
            >
              <PageBreadcrumbs />
            </div>
            <div className='default-base-layout-content'>
              <Outlet />
            </div>
          </div>
        </ErrorBoundary>
      </div>
    </div>
  );
};
